import { commonConstants } from '../constants'

export const initialState = {
  juso: ''
}

export default function common(state = initialState, action) {
  switch (action.type) {
    case commonConstants.ZIP_LOAD_REQUEST:
      return {
      }
    case commonConstants.ZIP_LOAD_SUCCESS:
      return {
        ...state,
        juso: action.response.results['juso'],
        pageInfo : action.response.results['common'],
      }
    case commonConstants.ZIP_LOAD_FAILURE:
      return {
      }
    case commonConstants.ZIP_LOAD_RESET:
      return {
        juso: '',
        pageInfo: null,
      }
    default:
      return state
  }
}
